import React from 'react';
import { sanitizeHtml } from 'utils';
import { CustomizedSwitch } from 'components';
import { goalGraphTypeEnums, graphTypeEnums } from '../../attributes/constnats';
import { resolveRichTextImages } from '../../../utils/resolveRichTextImages';
import { RichTextElement } from './richTextElement';
import { FormLineChart, FormBarChart } from '../../../fragments/formGraphs';
import { GraphCharts } from './graphCharts';

const DEMO_CATEGORIES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
const DEMO_SERIES = [{ name: 'Target', data: [20, 35, 45, 60, 72, 85] }];
const DEMO_BASELINE_PHASE = [
    { date: '2025-11-03', value: 10 },
    { date: '2025-11-05', value: 15 },
    { date: '2025-11-07', value: 12 },
];

export const TargetElement = ({
    item,
    index,
    value,
    onChange,
    readOnly,
    formList,
    setFormList,
    activeSection,
    isReportBuilder,
    isActive,
    sectionIndex,
    goalId,
    targetId,
    imageUrls = {},
    onImageUpload,
}) => {
    const chartSettings = item?.properties?.chartSettings || {};
    const showGraph = !!item?.properties?.showGraph;
    const demoBaselinePhase = item?.properties?.showBaseline ? DEMO_BASELINE_PHASE : undefined;

    const handlePropertyChange = (field, val) => {
        if (isReportBuilder) return;
        const sIndex = (activeSection || 1) - 1;
        const newFormList = { ...formList };
        const newAttributes = [...(newFormList.sections[sIndex]?.attributes || [])];
        newAttributes[index] = {
            ...newAttributes[index],
            properties: {
                ...newAttributes[index].properties,
                [field]: val,
            },
        };
        newFormList.sections[sIndex] = {
            ...newFormList.sections[sIndex],
            attributes: newAttributes,
        };
        setFormList(newFormList);
    };

    return (
        <div>
            {!isReportBuilder && !readOnly && (
                <div className="flex-end">
                    <div className="form-body-item-action" style={{ marginBottom: '6px' }}>
                        <CustomizedSwitch checked={showGraph} handleClick={() => handlePropertyChange('showGraph', !showGraph)} />
                        <p>Show Graph</p>
                    </div>
                </div>
            )}

            {readOnly || (isReportBuilder && !isActive) ? (
                <div>
                    {/*{isReportBuilder && (*/}
                    {/*    <p className="form-builder-attribute-title">*/}
                    {/*        {item?.label || item?.name}*/}
                    {/*    </p>*/}
                    {/*)}*/}
                    <div
                        style={{ cursor: readOnly ? 'default' : 'pointer' }}
                        className="richtext-readonly-content"
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(resolveRichTextImages(value || item?.value || '', imageUrls)) }}
                    />
                </div>
            ) : (
                <>
                    {/*{isReportBuilder && (*/}
                    {/*    <p className="form-builder-attribute-title">*/}
                    {/*        {item?.label || item?.name}*/}
                    {/*    </p>*/}
                    {/*)}*/}
                    <RichTextElement
                        item={item}
                        value={value}
                        onChange={onChange}
                        readOnly={readOnly}
                        activeSection={activeSection}
                        wrapperStyle={{ border: '1px solid #0C66E4' }}
                        imageUrls={imageUrls}
                        onImageUpload={onImageUpload}
                    />
                </>
            )}

            {showGraph && (
                <>
                    <div style={{ marginTop: isReportBuilder ? 16 : 0 }}>
                        {isReportBuilder ? (
                            <GraphCharts
                                item={{ ...item, defaultDateType: goalGraphTypeEnums.TARGET_OVERVIEW }}
                                sectionIndex={sectionIndex}
                                goalId={goalId}
                                targetId={targetId}
                            />
                        ) : (
                            <>
                                {(item?.properties?.graphType || graphTypeEnums.LINE) === graphTypeEnums.LINE && (
                                    <FormLineChart
                                        item={item}
                                        categories={DEMO_CATEGORIES}
                                        series={DEMO_SERIES}
                                        isPercent={true}
                                        seriesConfig={item?.properties?.chartSettings?.seriesConfig || []}
                                        baselinePhase={demoBaselinePhase}
                                    />
                                )}
                                {item?.properties?.graphType === graphTypeEnums.BAR && (
                                    <FormBarChart
                                        item={item}
                                        categories={DEMO_CATEGORIES}
                                        series={DEMO_SERIES}
                                        isPercent={true}
                                        seriesConfig={item?.properties?.chartSettings?.seriesConfig || []}
                                        baselinePhase={demoBaselinePhase}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
